import { registerDecorator, ValidationOptions, ValidationArguments } from "class-validator";
import { getErrorMessages } from "./translateErrors"; // TODO: mudar para i18n

// Compara a propriedade password com @ConfirmPassword
export function ConfirmPassword(validationOptions?: ValidationOptions) {
	return (object: Object, propertyName: string) => {
		registerDecorator({
			name: "confirmPassword",
			target: object.constructor,
			propertyName,
			constraints: [],
			options: validationOptions,
			validator: {
				validate(passwordConfirmation: any, args: ValidationArguments) {
					const { password } = args.object as any;
					return passwordConfirmation === password;
				},
				defaultMessage: (args: ValidationArguments) => getErrorMessages().confirmPassword,
			},
		});
	};
}

// Valida o formato de um número de telefone brasileiro
export function IsBrPhone(validationOptions?: ValidationOptions) {
	return (object: object, propertyName: string) => {
		registerDecorator({
			name: "isBrPhone",
			target: object.constructor,
			propertyName,
			constraints: [],
			options: validationOptions,
			validator: {
				validate(value: any, args: ValidationArguments): boolean {
					return typeof value === "string" && /^\((\d{2})\)\s(\d{4,5}-\d{4})$/.test(value);
				},
				defaultMessage: (args: ValidationArguments) => getErrorMessages().isBrPhone,
			},
		});
	};
}

function validateCPF(cpfInput: string) {
	const cpf = cpfInput.replace(/[^\d]+/g, "");
	if (cpf === "") { return false; }
	// Elimina CPFs invalidos conhecidos
	if (cpf.length !== 11 || cpf === "00000000000" || cpf === "11111111111" || cpf === "22222222222" || cpf === "33333333333"
		|| cpf === "44444444444" || cpf === "55555555555" || cpf === "66666666666" || cpf === "77777777777" || cpf === "88888888888" || cpf === "99999999999") {
		return false;
	}
	// Valida 1o digito
	let add = 0;
	for (let i = 0; i < 9; i += 1) {
		add += parseInt(cpf.charAt(i), 10) * (10 - i);
	}
	let rev = 11 - (add % 11);
	if (rev === 10 || rev === 11) {
		rev = 0;
	}
	if (rev !== parseInt(cpf.charAt(9), 10)) {
		return false;
	}
	// Valida 2o digito
	add = 0;
	for (let i = 0; i < 10; i += 1) {
		add += parseInt(cpf.charAt(i), 10) * (11 - i);
	}
	rev = 11 - (add % 11);
	if (rev === 10 || rev === 11) {
		rev = 0;
	}
	if (rev !== parseInt(cpf.charAt(10), 10)) {
		return false;
	}
	return true;
}

// Valida os dígitos verificadores de um CPF
export function IsCPF(validationOptions?: ValidationOptions) {
	return (object: object, propertyName: string) => {
		registerDecorator({
			name: "isCPF",
			target: object.constructor,
			propertyName,
			constraints: ["Check digits are invalid"],
			options: validationOptions,
			validator: {
				validate(value: any, args: ValidationArguments) {
					return typeof value === "string" && validateCPF(value);
				},
				defaultMessage: (args: ValidationArguments) => getErrorMessages().isCPF,
			},
		});
	};
}
